var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarMall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75001 5.59921C7.68322 5.59921 6.81836 4.73641 6.81836 3.66756V1.93165C6.81836 0.865379 7.68322 0 8.75001 0C9.8168 0 10.6817 0.865379 10.6817 1.93165V3.66756C10.6817 4.73641 9.8168 5.59921 8.75001 5.59921Z",
    fill: "#F7CA4B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75001 17.5011C7.68322 17.5011 6.81836 16.6357 6.81836 15.5694V13.8335C6.81836 12.7672 7.68322 11.9019 8.75001 11.9019C9.8168 11.9019 10.6817 12.7672 10.6817 13.8335V15.5694C10.6817 16.6357 9.8168 17.5011 8.75001 17.5011Z",
    fill: "#F7CA4B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66705 10.6834H1.93165C0.864864 10.6834 0 9.81799 0 8.75172C0 7.68545 0.864864 6.82007 1.93165 6.82007H3.66705C4.73383 6.82007 5.5987 7.68545 5.5987 8.75172C5.5987 9.81799 4.73383 10.6834 3.66705 10.6834Z",
    fill: "#F7CA4B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5684 10.6834H13.8328C12.766 10.6834 11.9011 9.81799 11.9011 8.75172C11.9011 7.68545 12.766 6.82007 13.8328 6.82007H15.5684C16.6352 6.82007 17.5001 7.68545 17.5001 8.75172C17.5001 9.81799 16.6352 10.6834 15.5684 10.6834Z",
    fill: "#F7CA4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarMall);
export default __webpack_public_path__ + "static/media/star_mall.82562034985c5f1b26cb037076763e11.svg";
export { ForwardRef as ReactComponent };